import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LorenLocationFilterDialogComponent } from './components/loren-location-filter-dialog/loren-location-filter-dialog.component';



@NgModule({
    declarations: [
        LorenLocationFilterDialogComponent
    ],
    exports: [
        LorenLocationFilterDialogComponent
    ],
    imports: [
        CommonModule
    ]
})
export class LorenLocationFilterDialogModule { }
